module.exports = __webpack_public_path__ + "static/solution-4ee1ca1305a1e58fe9c298347e3e123f.jpg";